import http from '@/service/axios'
import api from '@/service/api'
export default {
  querySupplierList({ commit }) {
    // 查询供应商列表
    http({
      url: api.supplierList,
      data: {
        page_no: 1,
        page_size: 9999,
        status: 1,
      },
      success: (res) => {
        commit('setState', { supplierList: res.result.supplierInfoVO || [] })
      },
    })
  },
}
